import { readApiJson } from '../utils/readApiJson';

const API_BASE_URL = '/api/prisme';

export interface ClientItem {
  id?: number;
  nom: string;
  secteur?: string;
  taille_entreprise?: string;
  nombre_employes?: number;
  enjeux_principaux?: string;
  gitrepository?: string | null;
  prismewebsite?: string | null;
  prismecompleted?: boolean | null;
  id_client_erp?: string | null;
  date_creation?: string;
  date_modification?: string;
  actif?: boolean;
  archived?: boolean;
  archived_at?: string;
}

export async function getAllClients(): Promise<ClientItem[]> {
  const res = await fetch(`${API_BASE_URL}/clients`, { credentials: 'include' });
  const data = await readApiJson<ClientItem[] | { error?: string }>(res);
  if (!res.ok) throw new Error((data as { error?: string })?.error || 'Erreur chargement clients');
  return data as ClientItem[];
}

export async function createClient(client: ClientItem): Promise<any> {
  const res = await fetch(`${API_BASE_URL}/client`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(client),
  });
  const data = await readApiJson<any>(res);
  if (!res.ok) throw new Error(data?.error || 'Erreur création client');
  return data;
}

export async function updateClient(id: number, updates: ClientItem): Promise<any> {
  const res = await fetch(`${API_BASE_URL}/client/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(updates),
  });
  const data = await readApiJson<any>(res);
  if (!res.ok) throw new Error(data?.error || 'Erreur mise à jour client');
  return data;
}

export async function deleteClient(id: number): Promise<any> {
  const res = await fetch(`${API_BASE_URL}/client/${id}`, { method: 'DELETE', credentials: 'include' });
  const data = await readApiJson<any>(res);
  if (!res.ok) throw new Error(data?.error || 'Erreur suppression client');
  return data;
}

export async function getClientById(id: number): Promise<ClientItem | null> {
  const res = await fetch(`${API_BASE_URL}/client/${id}`, { credentials: 'include' });
  if (res.status === 404) {
    await res.text();
    return null;
  }
  const data = await readApiJson<ClientItem | { error?: string }>(res);
  if (!res.ok) throw new Error((data as { error?: string })?.error || 'Erreur chargement client');
  return data as ClientItem;
}

export async function getArchivedClients(): Promise<ClientItem[]> {
  const res = await fetch(`${API_BASE_URL}/clients/archived`, { credentials: 'include' });
  const data = await readApiJson<ClientItem[] | { error?: string }>(res);
  if (!res.ok) {
    if (res.status === 403) throw new Error('Accès réservé aux administrateurs PRIsME');
    throw new Error((data as { error?: string })?.error || 'Erreur chargement des clients archivés');
  }
  return data as ClientItem[];
}

export async function archiveClient(id: number): Promise<any> {
  const res = await fetch(`${API_BASE_URL}/client/${id}/archive`, {
    method: 'POST',
    credentials: 'include',
  });
  const data = await readApiJson<any>(res);
  if (!res.ok) throw new Error(data?.error || "Erreur lors de l'archivage du client");
  return data;
}

export async function unarchiveClient(id: number): Promise<any> {
  const res = await fetch(`${API_BASE_URL}/client/${id}/unarchive`, {
    method: 'POST',
    credentials: 'include',
  });
  const data = await readApiJson<any>(res);
  if (!res.ok) throw new Error(data?.error || 'Erreur lors de la restauration du client');
  return data;
}
